import type { ReactNode } from 'react';
import useEntrance from '@/hooks/useInView';

interface InkSettleProps {
  as?: 'h2' | 'h3';
  className?: string;
  children: ReactNode;
}

/** Motion A — heading settles from muted ink to full colour; no movement. */
export default function InkSettle({ as: Tag = 'h2', className = '', children }: InkSettleProps) {
  const { ref, pending } = useEntrance<HTMLHeadingElement>(0.6);
  return (
    <Tag ref={ref} className={`mw-ink ${pending ? 'mw-ink-pending' : ''} ${className}`}>
      {children}
    </Tag>
  );
}